import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useMemo, useState } from 'react';
import useProductActions from './useProductActions';
/**
 * @param {import('@techstyle/react-types').CatalogProductFilterDto} inputFilters
 * @param inputOptions
 * @returns {Partial<import('@techstyle/react-types').CatalogProductFilterResponseDto>}
 */

export default function useProductListing(inputFilters, inputOptions) {
  var actions = useProductActions();

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      products = _useState2[0],
      setProducts = _useState2[1]; // eslint-disable-next-line react-hooks/exhaustive-deps


  var filters = useMemo(function () {
    return inputFilters;
  }, [JSON.stringify(inputFilters)]); // eslint-disable-next-line react-hooks/exhaustive-deps

  var options = useMemo(function () {
    return inputOptions;
  }, [JSON.stringify(inputOptions)]);
  useEffect(function () {
    var load = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return actions.loadProducts(filters, options);

              case 2:
                result = _context.sent;
                setProducts(result.payload);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();

    if (filters) {
      load();
    }
  }, [actions, filters, options]);
  return products;
}